import { DocumentStatus } from '@/types/document';
import { User } from '@/types/user';

import { isAboveYearsOld } from '@/utils/validation';

type MinorBasicInfo = Pick<
  User,
  'allowToDebitCardOnlineBanking' | 'birthday' | 'hasPhoneNumber'
>;

export function isMinorBasicInfoFullyComplete(
  basicInfoStatus: DocumentStatus | undefined,
  minorUser: MinorBasicInfo | undefined,
) {
  const questionsComplete =
    basicInfoStatus === DocumentStatus.InReview ||
    basicInfoStatus === DocumentStatus.Approved;
  const consentsComplete =
    !isAboveYearsOld(13, minorUser?.birthday) ||
    minorUser?.hasPhoneNumber === false ||
    minorUser?.allowToDebitCardOnlineBanking !== undefined;
  const othersComplete = minorUser?.hasPhoneNumber !== undefined;

  return questionsComplete && consentsComplete && othersComplete;
}
